import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/admin/ai-email")({
  component: () => <Navigate to="/admin/email-campaign-center" replace />,
});
